import React, {useEffect, useState, useCallback} from "react";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/tr";
import "moment/locale/ro";
import "moment/locale/ar-sa";
import PropTypes from "prop-types";
import {TextField} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import i18next from "i18next";
import "./Datepicker.Style.scss";
const localeMap = {
  ar: "ar-sa",
  tr: "tr",
  ro: "ro",
};
export const Datepicker = ({
  value,
  label,
  error,
  maxDate,
  minDate,
  onChange,
  isDisabled,
  helperText,
  valueDateFormat,
  inputPlaceholder,
  wrapperClasses,
}) => {
  const [localValue, setLocalValue] = useState(null);
  const onChangeHandler = useCallback(
    (newValue) => {
      setLocalValue(newValue);
      if (newValue && !moment(newValue).isValid()) return;

      if (onChange)
        onChange(
          (newValue && moment(newValue).locale("en").format(valueDateFormat)) ||
            null
        );
    },
    [onChange, valueDateFormat]
  );
  useEffect(() => {
    setLocalValue((item) =>
      value
        ? (value && moment(value, valueDateFormat).locale("en").toDate()) ||
          null
        : item
    );
  }, [value, valueDateFormat]);

  return (
    <div className={`date-picker-wrapper mb-3 ${wrapperClasses}`}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        dateLibInstance={moment}
        adapterLocale={localeMap[i18next.language] || "en"}
      >
        <DatePicker
          label={label}
          minDate={minDate}
          maxDate={maxDate}
          value={localValue}
          rawValue={localValue}
          disabled={isDisabled}
          helperText={helperText}
          placeholder={inputPlaceholder}
          inputFormat={valueDateFormat}
          onChange={onChangeHandler}
          renderInput={(params) => (
            <TextField {...params} fullWidth error={error} />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

Datepicker.propTypes = {
  error: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  helperText: PropTypes.string,
  valueDateFormat: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  wrapperClasses: PropTypes.string,
};
Datepicker.defaultProps = {
  value: undefined,
  label: undefined,
  error: undefined,
  maxDate: undefined,
  minDate: undefined,
  onChange: undefined,
  helperText: undefined,
  isDisabled: undefined,
  inputPlaceholder: undefined,
  valueDateFormat: "YYYY-MM-DD",
  wrapperClasses: "",
};
export default Datepicker;
